import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://mediapi.onlinepharmaque.in/api/v1";

const SubHeader = () => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(false);

  const navigate = useNavigate();

  // 🔹 Fetch Categories
  useEffect(() => {
    fetch(`${API}/getallcategory`)
      .then((res) => res.json())
      .then((data) => setCategories(data.category || []));
  }, []);

  // 🔹 Fetch Subcategories
  const fetchSub = async (name) => {
    const res = await fetch(`${API}/subcategories/${name}`);
    const data = await res.json();
    setSubCategories(data.result || []);
    setActiveCategory(name);
  };

  return (
    <div className="w-full border-t border-b bg-white relative">

      <div className="max-w-7xl mx-auto px-4">

        {/* ================= MOBILE + TABLET HEADER ================= */}
        <div className="flex justify-between items-center md:hidden py-3">
          <button
            onClick={() => setMobileMenu(true)}
            className="text-2xl"
          >
            ☰
          </button>
          <h2 className="font-semibold">Menu</h2>
        </div>

        {/* ================= DESKTOP MENU ================= */}
        <ul className="hidden lg:flex justify-center items-center gap-8 h-12 text-black font-medium">
          

          {categories.map((cat) => (
            <li
              key={cat._id}
              className="relative cursor-pointer group"
              onMouseEnter={() => fetchSub(cat.MaincategoryName)}
            >
              <span className="hover:text-emerald-600 transition">
                {cat.MaincategoryName}
              </span>

              {/* 🔥 DROPDOWN */}
              {activeCategory === cat.MaincategoryName && (
                <div
                  className="absolute left-0 top-12 bg-white shadow-2xl rounded-xl p-3 z-50 w-[500px] border 
                             max-h-[300px] overflow-y-auto custom-scroll"
                  onMouseLeave={() => setActiveCategory(null)}
                >
                  <div className="grid grid-cols-2 gap-3">
                    {subCategories.map((sub) => (
                      <div
                        key={sub._id}
                        onClick={() =>
                          navigate(
                            `/products/${encodeURIComponent(
                              sub.SubCateoryName
                            )}`
                          )
                        }
                        className="flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-emerald-50 hover:text-emerald-600 cursor-pointer transition"
                      >
                        <span className="w-2 h-2 bg-emerald-500 rounded-full"></span>
                        <span className="text-sm">
                          {sub.SubCateoryName}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* ================= MOBILE + TABLET DRAWER ================= */}
      {mobileMenu && (
        <div className="fixed inset-0 z-50 bg-black/40">

          {/* 🔥 Drawer with Slide Animation */}
          <div className="w-[80%] max-w-[320px] h-full bg-white p-4 overflow-y-auto transform transition-transform duration-300 translate-x-0">

            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-lg">Categories</h3>
              <button
                onClick={() => setMobileMenu(false)}
                className="text-xl"
              >
                ✕
              </button>
            </div>

            {/* Category List */}
            {categories.map((cat) => (
              <div key={cat._id} className="mb-3">

                {/* Main Category */}
                <div
                  className="font-medium py-2 border-b cursor-pointer flex justify-between"
                  onClick={() =>
                    activeCategory === cat.MaincategoryName
                      ? setActiveCategory(null)
                      : fetchSub(cat.MaincategoryName)
                  }
                >
                  {cat.MaincategoryName}
                  <span>
                    {activeCategory === cat.MaincategoryName ? "−" : "+"}
                  </span>
                </div>

                {/* Subcategories */}
                {activeCategory === cat.MaincategoryName && (
                  <div className="pl-3 mt-2 space-y-2">
                    {subCategories.map((sub) => (
                      <div
                        key={sub._id}
                        onClick={() => {
                          navigate(
                            `/products/${encodeURIComponent(
                              sub.SubCateoryName
                            )}`
                          );
                          setMobileMenu(false);
                        }}
                        className="text-sm text-gray-600 hover:text-emerald-600 cursor-pointer"
                      >
                        • {sub.SubCateoryName}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubHeader;